export default "__VITE_ASSET__EwRhdgw___"